"use client";

import { DrupalNode } from "next-drupal";
import { motion } from "framer-motion";
import { config } from "@/lib/config";
import Link from "next/link";
import { resolveLink } from "@/utils";

interface CardProps {
  data: DrupalNode;
}

export default function IconWithLinesCard({ data }: CardProps) {
  const isBlue = data.field_background_color === "blue";
  const isWhite = data.field_background_color === "white";
  const isGray = data.field_background_color === "gray";
  const isDarkDray = data.field_background_color === "dark_gray";

  const bgClass = isBlue
    ? "bg-[#003350]"
    : isWhite
    ? "bg-white"
    : isGray
    ? "bg-[#f9f9f9]"
    : isDarkDray
    ? "bg-mapGray"
    : "bg-white";

  return (
    <div
      id="approach"
      className={`${bgClass} py-[120px] betweenMobileTab:py-16 mobileMax:py-10 relative`}
    >
      <div className="mini-container">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0 }}
          className="remove-animation-fluctuation"
        >
          <h3
            className={`text-clip text-transparent bg-[linear-gradient(to_right,#48DBB2,#A0DDFF)] text-[32px] font-semibold text-center mb-[100px] betweenMobileTab:mb-16 mobileMax:mb-[100px]`}
          >
            {data?.field_title}
          </h3>
        </motion.div>

        {data?.field_add_card?.map((card: any, index: number) => (
          <div
            id={card?.field_links?.[0]?.title?.toLowerCase()}
            key={index}
            className="scroll-mt-[150px] mobileMax:mt-[70px] mt-[127px] mobileMax:mb-[40px] mb-[60px]"
          >
            <div className="flex justify-center gap-6 relative mobileMax:hidden mr-[20px] pt-1">
              {/* ===== Gradient Border Box ===== */}
              <div
                className="
        w-[700px] h-[120px]
        md:w-[800px] md:h-[140px]
        betweenMobileTab:w-[550px] betweenMobileTab:h-[140px]
        aboveLaptop:w-[800px] aboveLaptop:h-[120px]
        desktop:w-[840px] desktop:h-[152px]
        border-t-4 border-l-4 border-transparent
        absolute left-[40px] betweenMobileTab:left-[69px] aboveLaptop:left-[65px] desktop:left-[92px]
      "
                style={{
                  borderImage:
                    "linear-gradient(to left bottom, #48DBB2, #4FC0FF) 1",
                  borderImageSlice: 1,
                }}
              ></div>

              {/* ===== Button Section ===== */}
              <div
                className="
        relative
        tab:absolute
        betweenMobileTab:right-[-18px] betweenMobileTab:top-[-25px]
        aboveLaptop:right-[60px] aboveLaptop:top-[-24px]
        desktop:right-[-22px] desktop:top-[-31px]
      "
              >
                <Link href={resolveLink(card?.field_links?.[0]?.uri) || "#"}>
                  <button
                    className="w-[200px] h-[55px] md:w-[250px] md:h-[60px] desktop:w-[277px] desktop:h-[62px]
            bg-gradient-to-r from-[#4FC0FF] to-[#5DE29B]
            text-[#003350] text-[18px] md:text-[20px] desktop:text-[22px]
            font-bold rounded-[171px]"
                  >
                    {card?.field_links?.[0]?.title}
                  </button>
                </Link>
              </div>
            </div>

            <div className="hidden mobileMax:flex justify-center">
              <Link href={resolveLink(card?.field_links?.[0]?.uri) || "#"}>
                <button
                  className="w-[200px] h-[55px] 
          bg-gradient-to-r from-[#4FC0FF] to-[#5DE29B]
          text-[#003350] text-[18px] font-bold rounded-[171px] mb-[30px]"
                >
                  {card?.field_links?.[0]?.title}
                </button>
              </Link>
            </div>

            <div className="flex flex-col betweenMobileTab:flex-row desktop:flex-row items-center gap-[30px] mt-[0px] betweenMobileTab:mt-[100px] aboveLaptop:mt-[100px] desktop:mt-[150px] relative pb-[20px]">
              <div className="mobileMax:w-[150px] mobileMax:h-[150px]">
                <img
                  className=""
                  src={`${config.apiBase}${card?.field_icon?.uri?.url}`}
                  alt=""
                />
              </div>

              <div>
                <img
                  className="rotate-90 w-[35px] mobileMax:block hidden"
                  src="/static/images/mission-arrow.png"
                  alt=""
                />
              </div>

              <div className="max-w-[920px] w-full">
                <div
                  className="text-[18px] text-white mobileMax:mt-[10px] [&>ul]:list-disc [&>ul]:pl-5 [&>ul>li]:mt-2"
                  dangerouslySetInnerHTML={{
                    __html: card?.field_description?.processed,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
